export default __webpack_public_path__ + "static/media/mental-health-icon.14fd8bf4.svg";